import { QueryClient } from '@tanstack/react-query';

import { parseHospitalTreatmentVo } from '@/parsers/f2f/hospital';

import { useFaceToFaceTreatmentKeywordsQuery } from './hospitalMain.gql.impl';

const useFaceToFaceTreatmentKeywords = () => {
  const { data } = useFaceToFaceTreatmentKeywordsQuery(undefined, {
    select: parseHospitalTreatmentVo,
  });
  return { data };
};

export default useFaceToFaceTreatmentKeywords;

useFaceToFaceTreatmentKeywords.prefetchQuery = async (
  queryClient: QueryClient,
) => {
  await queryClient.prefetchQuery(
    useFaceToFaceTreatmentKeywordsQuery.getKey(),
    useFaceToFaceTreatmentKeywordsQuery.fetcher(),
  );
};
